/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:48 GMT
 *
 */


const theme = {
  appearances: {
    focus: {
      description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    hover: {
      description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    pressed: {
      description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    }
  },
  rules: [
    { if: { hover: true }, tokens: { borderWidth: 2 } },
    { if: { pressed: true }, tokens: { backgroundColor: '#f4f4f7' } },
    {
      if: { focus: true },
      tokens: {
        outerBorderColor: '#676e73',
        outerBorderGap: 2,
        outerBorderWidth: 2
      }
    }
  ],
  tokens: {
    backgroundColor: '#ffffff',
    borderColor: '#e3e6e8',
    borderRadius: 6,
    borderWidth: 1,
    flex: 1,
    outerBorderColor: 'rgba(0, 0, 0, 0)',
    outerBorderGap: 0,
    outerBorderWidth: 0,
    paddingBottom: 0,
    paddingLeft: 0,
    paddingRight: 0,
    paddingTop: 0,
    separatorColor: '#b2b9bf'
  }
}
export default theme
